import React, { useContext } from 'react';
import { Image, Message } from 'semantic-ui-react';
import { MentionsInput, Mention } from 'react-mentions';
import { withTranslation } from 'react-i18next';
import styled, { ThemeContext } from 'styled-components';
import util from 'utils/utils';

const StyledSuggestion = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const StyledSuggestionInfo = styled.div`
  color: ${props => (props.focused ? '#fff' : '#000')};
  display: flex;
  flex-direction: column;
  margin-left: 5px;
`;

const StyledInfo = styled.span`
  margin-top: 0px;
  margin-bottom: 0px;
  ${props => props.meta && 'color: gray'}
`;
const MentionsContainer = styled.div`
  .mentionsBox {
  }
`;

const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  border: 0.5px solid #c9c9c9;
  border-radius: 5px;
  background-color: #fff;
`;

const ActionsContainer = styled.div`
  margin: 0 5px;
  border-top: 0.5px solid silver;
  padding: 0;
`;

const MentionsChip = ({
  comment, updateComment, searchForMention, searchForHashtags, placeholder, t, recommendPinning, canManage, actions,
}) => {
  const theme = useContext(ThemeContext);
  const renderSuggestion = (entry, search, highlightedDisplay, index, focused) => (
    <StyledSuggestion>
      <Image avatar src={util.avatarUrl(entry)} style={{ marginRight: 5 }} />
      <StyledSuggestionInfo focused={focused}>
        <StyledInfo>{entry.display}</StyledInfo>
        {util.getProfileJob(entry) && <StyledInfo meta>{util.getProfileJob(entry)}</StyledInfo>}
      </StyledSuggestionInfo>
    </StyledSuggestion>
  );

  return (
    <MentionsContainer>
      {recommendPinning && canManage
        && (
        <Message size="tiny" info style={{ display: 'inline-block', width: '100%', marginTop: 10 }}>
          <Message.Header>Why not pin a post?</Message.Header>
          <p>Pinning a post can be useful to explain the purpose of the discussion and helps to drive user engagement. To pin a post, find an existing entry in the feed below and tap "Pin comment".</p>
        </Message>
        )
      }
      <InputContainer>
        <MentionsInput
          placeholder={placeholder || t('ideas.comments.delete.write')}
          value={comment}
          onChange={e => updateComment(e.target.value)}
          allowSuggestionsAboveCursor
          allowSpaceInQuery
          className="mentionsBox"
          style={{
            control: {
              backgroundColor: '#fff',
              fontSize: 12,
              fontWeight: 'normal',
              border: '0px solid gray',
              borderRadius: 5,
            },
            highlighter: {
              overflow: 'hidden',
              borderRadius: 5,
              border: '0px solid gray',
            },
            input: {
              margin: 0,
              border: '0px solid gray',
            },
            '&singleLine': {
              control: {
                display: 'inline-block',
                width: 130,
              },
              highlighter: {
                padding: 1,
                border: '2px inset transparent',
              },
              input: {
                padding: 1,
                border: '2px inset',
              },
            },
            '&multiLine': {
              control: {
                border: '0px',
              },
              highlighter: {
                padding: 10,
              },
              input: {
                padding: 10,
                minHeight: 63,
                outline: 0,
                border: 0,
                fontSize: '1.2em',
              },
            },
            suggestions: {
              list: {
                backgroundColor: 'white',
                border: '0.5px solid lightgray',
                borderRadius: 5,
                fontSize: 10,
              },
              item: {
                padding: '10px 12px',
                borderRadius: 5,
                '&focused': {
                  backgroundColor: theme.accent,
                },
              },
            },
          }}
          markup="(__type__)[__display__](_id:__id__)"
        >
          {searchForMention && (
            <Mention
              type="@"
              trigger="@"
              data={searchForMention}
              style={{
                backgroundColor: 'rgba(0,0,0,0.1)',
                borderRadius: 3,
              }}
              renderSuggestion={renderSuggestion}
            />
          )}
          {searchForHashtags && (
            <Mention
              type="#"
              trigger="#"
              data={this.searchForHashtags}
              style={{
                backgroundColor: theme.accent,
              }}
            />
          )}
        </MentionsInput>
        <ActionsContainer>
          {actions}
        </ActionsContainer>
      </InputContainer>
    </MentionsContainer>
  );
};

export default withTranslation()(MentionsChip);
